import React, { Component } from "react";

export default class Home extends Component {
  render() {
    return (
      <div>
        <h3 className="home-headline">Welcome to Pharmacy ABC</h3>
      </div>
    );
  }
}
